// Copyright (c) StrangeBee 2023

import { classList } from '@Helpers/className';
import { DatePicker } from 'antd';
import { PickerDateProps } from 'antd/lib/date-picker/generatePicker';
import React, { ReactElement } from 'react';
import { Moment } from 'moment';
import moment from 'moment';
import { useStorageOptions } from '@Hooks/useStorageOptions';

import './THDatePicker.scss';

interface THDatePickerProps extends PickerDateProps<Moment> {
    borderless?: boolean;
}

export const THDatePicker = ({ borderless = false, className, value, ...props }: THDatePickerProps): ReactElement => {
    const { defaultDateFormat } = useStorageOptions();

    return (
        <DatePicker
            className={classList('th-date-picker', className, { 'no-border': borderless })}
            format={defaultDateFormat}
            dropdownClassName="th-date-picker__dropdown"
            value={typeof value === 'number' && value !== undefined ? moment(value) : value}
            {...props}
        />
    );
};
